import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { initializeNativeIosShell } from "@/lib/nativeIosShell";
import ReleaseProvenanceGate from "@/components/ReleaseProvenanceGate";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
function renderApp() {
  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <ReleaseProvenanceGate>
          <App />
        </ReleaseProvenanceGate>
      </QueryClientProvider>
    </React.StrictMode>,
  );
}

initializeNativeIosShell().then(renderApp).catch(() => {
  // Do not conceal missing native plugins or proceed with a broken native shell.
  root.render(
    <div className="login-safe-area px-5" role="alert">
      Impossibile inizializzare la schermata iOS. Aggiorna l’app alla versione
      nativa più recente e riaprila.
    </div>
  );
});
